import * as types from './action-types';
// import { PanelProxy } from '../../../proxies';

const clearData = () => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({type: types.SET_SINGLE_MEMBERSHIP_DATA, payload: { data: {id:null}, key: 'userData'}});
  });
};

export default {
  clearData
}


// WEBPACK FOOTER //
// ./src/store/modules/membership/actions.js